import { FlatActionButton } from "@caisy/league";
import Link from "next/link";
import React from "react";
import { I18n } from "../../../../provider/i18n";
import { ListenerEntrypoint } from "../../../../stores/entrypoint/useEntrypoint";
import LogoFull from "../../../atom/logoFull/LogoFull";
import { SLoginHeader } from "../../../molecule/login-header/styles/SLoginHeader";
import { SLoginHeaderWrapper } from "../../../molecule/login-header/styles/SLoginHeaderWrapper";

export const RegisterContactInfoHeader: React.FC = () => {
  return (
    <SLoginHeader>
      <ListenerEntrypoint />
      <LogoFull />
      <SLoginHeaderWrapper>
        <I18n selector="login.welcome_AlreadyHaveAnAccount" fallback="Already have an account?" />
        <Link href="https://app.caisy.io/app/login">
          <FlatActionButton type="grey">
            <I18n selector="login.welcome_signIn" fallback="Sign in" />
          </FlatActionButton>
        </Link>
      </SLoginHeaderWrapper>
    </SLoginHeader>
  );
};
